import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const CouponIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M21 4.5H1.5V8L3 8.5L4.5 10L5 12L4.5 14L3 15.5L1 16V20H19.5L22 19L22.5 18L23 8.5L22 5.5L21 4.5Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.462494 3.74677H20.6875C22.2615 3.74677 23.5375 5.02275 23.5375 6.59677V17.6343C23.5375 19.2083 22.2615 20.4843 20.6875 20.4843H0.462494V15.123L1.31249 15.123C2.74303 15.123 4.01829 13.843 4.01829 12.1155C4.01829 10.3881 2.74303 9.10807 1.31249 9.10807L0.462494 9.10807V3.74677ZM2.16249 5.44677V7.49441C4.23 7.9216 5.71829 9.87849 5.71829 12.1155C5.71829 14.3525 4.23 16.3094 2.16249 16.7366V18.7843H20.6875C21.3226 18.7843 21.8375 18.2694 21.8375 17.6343V6.59677C21.8375 5.96164 21.3226 5.44677 20.6875 5.44677H2.16249Z"
        fill="currentColor"
      />
      <path
        d="M18.8625 12.1155C18.8625 13.0372 18.1154 13.7843 17.1937 13.7843C16.2721 13.7843 15.525 13.0372 15.525 12.1155C15.525 11.1939 16.2721 10.4468 17.1937 10.4468C18.1154 10.4468 18.8625 11.1939 18.8625 12.1155Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CouponIconFilled;
